import React from "react";
import "../styles/AISparkIcon.css";

export default function AISparkIcon() {
  return <span className="ai-spark-icon" aria-hidden="true"><svg viewBox="0 0 32 32" fill="none"><path d="M16 3C17.5 11 21 14.5 29 16C21 17.5 17.5 21 16 29C14.5 21 11 17.5 3 16C11 14.5 14.5 11 16 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /></svg></span>;
}
